import { useMediaQuery } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigation } from 'swiper/modules';
import { Swiper as SwiperComponent, SwiperSlide } from 'swiper/react';
import { styleHandling, undoStyle } from '../../../js/styleHandling';
import { setSelectedStyleID } from '../../../redux-tool/slice/toolSlice';
import '../../styles/Style.css';

export function Style({ styles, styleIndex, handleStyleIndex }) {
  const dispatch = useDispatch();
  const { selectedStyleID } = useSelector((state) => state.tool);
  const slides = [...(Array.isArray(styles) ? styles : [])].filter(() => true);
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);
  const isSmallScreen = useMediaQuery('(max-height:600px)');
  const isLargeScreen = useMediaQuery('(min-height:1200px)');

  // Safe style application function
  const applyStyleSafely = (style) => {
    if (!style || !style.Id || !style.main_texture) return;

    // Check if this style is already applied
    if (window.currentAppliedStyleId === style.Id) {
      return;
    }

    // Apply the style
    if (styleHandling) {
      styleHandling.applyStyleToAllSections(style);
      window.currentAppliedStyleId = style.Id;
    }
  };

  useEffect(() => {
    if (styleIndex !== undefined && swiperRef.current) {
      let selectedStyleIndex = styleIndex;
      if (window.currentStyle?.Id) {
        const foundIndex = slides.findIndex((item) => item.Id === window.currentStyle.Id);
        if (foundIndex !== -1) {
          selectedStyleIndex = foundIndex;
        }
      }

      // Điều khiển slide active khi styleIndex thay đổi
      swiperRef.current.slideTo(selectedStyleIndex, 500);
      setActiveIndex(selectedStyleIndex);

      const selectedStyle = slides[selectedStyleIndex];
      if (selectedStyle && selectedStyle.main_texture && styleHandling) {
        applyStyleSafely(selectedStyle);
      }
    }
  }, [slides, styleIndex]);

  useEffect(() => {
    const styleIndex = slides.findIndex((item) => item.Id === selectedStyleID);
    handleStyleIndex(styleIndex);
  }, [selectedStyleID]);

  useEffect(() => {
    if (undoStyle.length > 0) {
      window.setClearState(true);
    }
  }, []);

  return (
    <SwiperComponent
      direction="vertical"
      slidesPerView={isSmallScreen ? 3 : isLargeScreen ? 6 : 4}
      modules={[Navigation]}
      initialSlide={Number(styleIndex) || 0}
      ref={swiperRef}
      onSwiper={(swiper) => {
        swiperRef.current = swiper;
      }}
      onActiveIndexChange={(swiper) => {
        if (slides && slides.length > 0) {
          const _styleIndex = swiper.activeIndex;
          setActiveIndex(_styleIndex);
          handleStyleIndex(_styleIndex);
          if (_styleIndex >= 0 && _styleIndex < slides.length) {
            const selectedStyle = slides[_styleIndex];
            dispatch(setSelectedStyleID(String(slides[_styleIndex].Id)));
            if (selectedStyle && selectedStyle.main_texture && styleHandling) {
              styleHandling.updateUndoStyle(selectedStyle);
              applyStyleSafely(selectedStyle);
            }
          }
        }
      }}
      className="style-tablet-swiper"
    >
      {slides?.map((item, index) => (
        <SwiperSlide
          key={index}
          onClick={() => {
            handleStyleIndex(index);
            setActiveIndex(index);
            if (item && item.main_texture) {
              dispatch(setSelectedStyleID(String(item.Id)));
              styleHandling.updateUndoStyle(item);
              applyStyleSafely(item);
            }
          }}
          className="style-tablet-slide"
        >
          <img
            src={item.Thumbnail}
            className={`${activeIndex === index ? 'active' : ''}`}
            alt={`Design ${index + 1}`}
          />
        </SwiperSlide>
      ))}
    </SwiperComponent>
  );
}
